import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";
import type {
    ILoaderSize,
    ILoaderType,
} from "@swiggy-private/dls-web-core/dist/components/Loader/types";

export const LOADER_TYPE: ILoaderType = "secondary";
export const LOADER_SIZE: ILoaderSize = "xxLarge";
export const LOADER_BACKGROUND_COLOR: keyof IColors = "background_Button_Secondary";
